import React from 'react';
import { cn } from './lib/utils';

export const Button = ({ 
  children, 
  className = '', 
  variant = 'default', 
  size = 'default', 
  disabled = false,
  ...props 
}) => {
  const baseClass = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 relative';
  
  const variantClasses = {
    default: disabled 
      ? 'bg-gray-400 text-white cursor-not-allowed' 
      : 'bg-brand-600 text-white hover:bg-brand-700 focus:ring-brand-500',
    outline: disabled 
      ? 'border border-gray-300 bg-transparent text-gray-400 cursor-not-allowed' 
      : 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:ring-gray-500',
    ghost: disabled
      ? 'bg-transparent text-gray-400 cursor-not-allowed'
      : 'bg-transparent text-gray-700 hover:bg-gray-100 focus:ring-gray-500',
    secondary: disabled
      ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
      : 'bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-gray-500',
    destructive: disabled
      ? 'bg-red-300 text-red-100 cursor-not-allowed'
      : 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
    primary: disabled
      ? 'bg-brand-300 text-brand-100 cursor-not-allowed'
      : 'bg-brand-600 text-white hover:bg-brand-700 focus:ring-brand-500',
  };
  
  const sizeClasses = {
    default: 'h-10 py-2 px-4 text-sm',
    sm: 'h-8 px-3 text-xs',
    lg: 'h-12 px-6 text-base',
    icon: 'h-10 w-10 p-0',
  };

  // Every other control in this kit composes through cn(), which is
  // twMerge(clsx(...)) and drops a base class when the caller overrides it.
  // This one concatenated strings, so a passed className did not replace the
  // size — both shipped and CSS order decided. An icon button written as
  // "h-6 w-6 p-0" kept the default px-4 and rendered at zero content width;
  // the eye on «Учетные данные» was invisible for exactly that reason.
  const buttonClass = cn(
    baseClass,
    variantClasses[variant] || variantClasses.default,
    sizeClasses[size] || sizeClasses.default,
    className
  );

  return (
    <button className={buttonClass} disabled={disabled} {...props}>
      {children}
    </button>
  );
};

export const buttonVariants = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
};